import React from 'react';
import { IconButton } from '@mui/material';
import TimelineRoundedIcon from '@mui/icons-material/TimelineRounded';

import { usePatientIntakeStatusContext } from '../hooks';
import { HistoryDialog, useHistoryDialog } from '../HistoryDialog';

export const GlobalHistoryButton = () => {
  const { isHealthcareProvider } = usePatientIntakeStatusContext();
  const { isOpen, setIsOpen } = useHistoryDialog();

  const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleOnClose = () => {
    setIsOpen(false);
  };

  if (!isHealthcareProvider) {
    return null;
  }

  return (
    <>
      <IconButton
        onClick={handleOnClick}
        title="View global history"
        sx={{ p: 0, width: 24, height: 24, border: 'divider' }}
      >
        <TimelineRoundedIcon fontSize="small" />
      </IconButton>

      {isOpen && <HistoryDialog open={isOpen} onClose={handleOnClose} />}
    </>
  );
};
